import React from 'react';
import { FaFacebook, FaShareAlt } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';

const FloatingShareButton = () => {
  const { language } = useLanguage();
  const currentUrl = window.location.href;
  const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;

  const label = language === 'ar' ? 'مشاركة' : 'Partager';

  return (
    <div style={styles.container}>
      <a 
        href={shareUrl} 
        target="_blank" 
        rel="noopener noreferrer" 
        style={styles.button}
        title={label}
      >
        <FaFacebook style={styles.icon} />
        <span style={styles.text}>{label}</span>
      </a>
      <div style={styles.mainIcon}>
        <FaShareAlt size={20} />
      </div>
    </div>
  );
};

const styles = {
  container: {
    position: 'fixed',
    bottom: '30px',
    right: '30px',
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column-reverse',
    alignItems: 'center',
    gap: '10px'
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    background: '#1877f2',
    color: 'white',
    padding: '12px 20px',
    borderRadius: '30px',
    textDecoration: 'none',
    boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
    transition: 'transform 0.3s, background 0.3s',
    cursor: 'pointer'
  },
  icon: {
    fontSize: '20px'
  },
  text: {
    fontWeight: 'bold',
    fontSize: '14px'
  },
  mainIcon: {
    width: '50px',
    height: '50px',
    background: '#c41e3a',
    color: 'white',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
    cursor: 'pointer'
  }
};

export default FloatingShareButton;
